// @flow
import React, { useContext, type Node } from 'react';

import { COLORS } from 'Components/utils/color/colors';
import { ReactPageContext } from 'Context/pageContext';

import { NavigationTabs } from 'Components/widgets/navigation-tabs/NavigationTabs.jsx';
import { Line, type LineProps } from 'Components/frameworks/line/Line.jsx';

type Props = {
  config: CMSContent,
  lines: Array<{
    props: {
      id: string,
      isExclusiveCollection: boolean,
      title: string,
      lines: $ReadOnlyArray<LineProps>,
    },
    name: string,
  }>,
};

export function NavigationTabsLine({
  config: {
    common: { scrollBackward, scrollForward },
  },
  lines = [],
}: Props) {
  const { pageType } = useContext(ReactPageContext);

  const items = lines.map(line => {
    const { id, isExclusiveCollection, title, lines: tabLines } = line.props;

    return {
      id,
      color: isExclusiveCollection ? COLORS.DEEP_BLUE : COLORS.BLUE,
      title,
      content: tabLines.map<Node>(Line),
      trackingData: {
        categoryGA: pageType,
        actionGA: 'blockInfos',
        labelGA: id || 'productInfos',
      },
    };
  });

  if (!items.length) {
    return null;
  }

  return items.length > 1 ? (
    <NavigationTabs
      className="Line"
      items={items}
      scrollBackwardLabel={scrollBackward}
      scrollForwardLabel={scrollForward}
    />
  ) : (
    items[0].content
  );
}
